import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3498db',
      light: '#5dade2',
      dark: '#2980b9',
    },
    secondary: {
      main: '#e74c3c',
      light: '#ec7063',
      dark: '#c0392b',
    },
    background: {
      default: '#1e1e2e',
      paper: '#252537',
    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
  },
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
      fontSize: '2rem',
      color: '#ffffff',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.5rem',
      color: '#ffffff',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',
      color: '#ffffff',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      color: 'rgba(255, 255, 255, 0.9)',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#252537',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#252537',
          borderRadius: '12px',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '8px',
            '& fieldset': {
              borderColor: 'rgba(255, 255, 255, 0.2)',
            },
            '&:hover fieldset': {
              borderColor: '#3498db',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#3498db',
              borderWidth: '2px',
            },
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '0.95rem',
        },
        contained: {
          background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
          boxShadow: '0 4px 15px rgba(52, 152, 219, 0.3)',
          '&:hover': {
            background: 'linear-gradient(135deg, #2980b9 0%, #21618c 100%)',
            boxShadow: '0 6px 20px rgba(52, 152, 219, 0.4)',
          },
        },
        outlined: {
          borderColor: '#3498db',
          color: '#3498db',
          '&:hover': {
            borderColor: '#5dade2',
            backgroundColor: 'rgba(52, 152, 219, 0.1)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(52, 152, 219, 0.2)',
          color: '#5dade2',
          border: '1px solid rgba(52, 152, 219, 0.3)',
          fontWeight: 500,
        },
      },
    },
  },
});